import React from 'react';
export function BonusSection() {
  const scrollToCompra = () => {
    const el = document.getElementById('compra');
    if (el) {
      el.scrollIntoView({
        behavior: 'smooth'
      });
    }
  };
  const bonuses = [{
    id: 1,
    title: 'Recetario Especial de Budines Salados',
    desc: 'Una colección de recetas fáciles para preparar budines salados perfectos para meriendas, reuniones o comidas rápidas.',
    img: 'https://cdn.magicpatterns.com/uploads/t8fgheMQai3NxcKNz6Y6an/bono_1.png'
  }, {
    id: 2,
    title: 'Guía de Coberturas y Glaseados para Budines',
    desc: 'Aprendé a transformar cualquier budín simple en un postre espectacular con glaseados, rellenos y coberturas fáciles.',
    img: 'https://cdn.magicpatterns.com/uploads/dKoPSCRCnvvLVAhiYVtAa9/bono_2.png'
  }, {
    id: 4,
    title: 'Tabla de Conversiones y Trucos de Repostería',
    desc: 'Equivalencias de ingredientes, medidas y tips esenciales para que todas tus recetas salgan perfectas.',
    img: 'https://cdn.magicpatterns.com/uploads/fLQ9R9S39YUdvCpkZwNgTr/bono_4.png'
  }];
  return <section className="py-20 px-4 bg-[#FEF3E2]" data-id="element-23">
      <div className="max-w-6xl mx-auto" data-id="element-24">
        <div className="text-center mb-16" data-id="element-25">
          <h2 className="text-3xl md:text-4xl font-bold text-[#3C1518] mb-4" data-id="element-26">
            Pero eso no es todo.
          </h2>
          <p className="text-xl text-[#C2410C] font-medium" data-id="element-27">
            Para que puedas sacarle el máximo provecho a este recetario, también
            vas a recibir bonos exclusivos incluidos con tu compra.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8" data-id="element-28">
          {bonuses.map(bonus => <div key={bonus.id} onClick={scrollToCompra} className="group cursor-pointer bg-white rounded-2xl overflow-hidden border border-[#E8D5C0] hover:border-[#EA580C] transition-all duration-300 transform hover:-translate-y-2 flex flex-col" data-id="element-29">
              <div className="relative p-6 bg-gradient-to-b from-[#FEF3E2] to-[#FFF8F0] flex justify-center items-center h-64" data-id="element-30">
                <div className="absolute top-4 right-4 bg-red-600 text-white text-xs font-bold px-3 py-1 rounded-full z-10" data-id="element-31">
                  GRATIS POR HOY
                </div>
                <img src={bonus.img} alt={`Bono ${bonus.id}: ${bonus.title}`} className="max-h-full w-auto object-contain drop-shadow-xl group-hover:scale-105 transition-transform duration-300" data-id="element-32" />
              </div>
              <div className="p-6 flex-1 flex flex-col" data-id="element-33">
                <div className="text-[#C2410C] font-bold text-sm mb-2 tracking-wider" data-id="element-34">
                  BONO {bonus.id}
                </div>
                <h3 className="text-xl font-bold text-[#3C1518] mb-3" data-id="element-35">
                  {bonus.title}
                </h3>
                <p className="text-[#92400E] text-sm leading-relaxed flex-1" data-id="element-36">
                  {bonus.desc}
                </p>
              </div>
            </div>)}
        </div>
      </div>
    </section>;
}